import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from "@angular/core";
import { Router } from "@angular/router";
import { ButtonDirective } from "primeng/button";
import { Popover } from "primeng/popover";
import { PopoverArrowDirective } from "../../popover/popover-arrow.directive";
import { role } from "../../../user/role.const";
import { UserService } from "../../../user/user.service";
import { organizationTab } from "../../../organization/organization-tab.const";

@Component({
  selector: "app-online-carrier-info",
  templateUrl: "./online-carrier-info.component.html",
  styleUrls: ["./online-carrier-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, Popover, PopoverArrowDirective],
})
export class OnlineCarrierInfoComponent {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  // Only an organization admin can open the organization form the button leads to.
  public readonly organizationId = signal<number | null>(null);

  constructor() {
    this.userService.getUser().then(
      (user) => {
        if (user?.hasRole(role.organizationAdmin)) {
          this.organizationId.set(user.organization?.getId() ?? null);
        }
      },
      () => undefined,
    );
  }

  public openIntegrations(): void {
    this.router.navigate(["organization", this.organizationId()], {
      queryParams: { tab: organizationTab.integrations },
    });
  }
}
